import axios from 'axios';
import { BASE_URL, COMMONS_SERVICE_BASE_URL } from './environments';
import { postDataOptions } from '../services/backendServices';

// APIs
const SEND_OTP_API = 'auth/login';
const VERIFY_OTP_API = 'auth/otpVerification';
const CHECK_MOBILE_API = 'api/login/checkMobile';
const REGISTER_API = 'auth/register';
const VERIFY_EMAIL_API = 'api/login/resendConfirmationEmail/';
const UPDATE_MOBILE = 'api/login/updateMobile';
const LOGOUT_API = 'api/v2/login/logout';

// Services
export const sendOTPService = async (payload) => {
  try {
    const response = await axios(postDataOptions(COMMONS_SERVICE_BASE_URL, SEND_OTP_API, payload));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const verifyEmailService = async (email_address) => {
  try {
    // let URL = VERIFY_EMAIL_API.replace('{email_address}',payload);
    const response = await axios(postDataOptions(BASE_URL, VERIFY_EMAIL_API + `${email_address}?repCode=&courseSlug=&force=true`, {}));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const verifyOTPService = async (payload) => {
  try {
    const response = await axios(postDataOptions(COMMONS_SERVICE_BASE_URL, VERIFY_OTP_API, payload));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const checkMobileService = async (payload) => {
  try {
    const response = await axios(postDataOptions(BASE_URL, CHECK_MOBILE_API, payload));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const registerUserService = async (payload) => {
  try {
    const response = await axios(postDataOptions(COMMONS_SERVICE_BASE_URL, REGISTER_API, payload));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateMobileService = async (payload) => {
  try {
    const response = await axios(postDataOptions(BASE_URL, UPDATE_MOBILE, payload));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const logoutService = async () => {
  try {
    const response = await axios(postDataOptions(BASE_URL, LOGOUT_API));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
